/* eslint-disable react/destructuring-assignment */
import { t } from 'i18next';

import { IKEOrganizationSubscriptionOverview } from '../../../../../../models/interfaces/Subscription/KidnapAndExtortion/KEOrganizationSubscriptionOverview';
import { FractionRenderer } from '../../../../../../styledComponents/MaterialTable/CellRenderers/CellRenderers';
import { overSubscribedSummaryRenderer } from '../../../../../../styledComponents/MaterialTable/CellRenderers/OverSubscribedSummaryRenderer/OverSubscribedSummaryRenderer';
import { Total } from './keSubscriptionOverviewPlansTable.styles';

export const getSummaryRow = (
  subscriptionOverview: IKEOrganizationSubscriptionOverview,
  onSeeOversubscribedMembers?: () => void,
  permissions?: string[],
) => {
  if (!subscriptionOverview) {
    return null;
  }

  return {
    price: <Total>{`${t('phrase.total')}`}</Total>,
    membershipsInUse: (
      <FractionRenderer
        isSummary
        maxValue={subscriptionOverview.totalCapacity}
        value={subscriptionOverview.totalMembershipsInUse}
      />
    ),
    oversubscribed: overSubscribedSummaryRenderer(
      subscriptionOverview?.totalIsOversubscribed,
      onSeeOversubscribedMembers,
      permissions,
    ),
  };
};
